<template>
  <div class="bg-white rounded-lg p-6 shadow-xl">
    <div class="text-left">
      <div class="text-green-600 font-semibold">{{ title }}</div>
      <div class="text-2xl text-gray-600">{{ value }}</div>
      <a-row>
        <a-col :span="3">
          <alipay
            theme="filled"
            size="20"
            fill="#4a90e2"
            :strokeWidth="1"
            strokeLinejoin="bevel"
          />
        </a-col>
        <a-col :span="6">{{ alipay }}</a-col>
        <a-col :span="3">
          <wechat
            theme="filled"
            size="20"
            fill="#4a90e2"
            :strokeWidth="1"
            strokeLinejoin="bevel"
          />
        </a-col>
        <a-col :span="6">{{ wechat }}</a-col>
        <a-col :span="3">
          <app-store
            theme="filled"
            size="20"
            fill="#4a90e2"
            :strokeWidth="1"
            strokeLinejoin="bevel"
          />
        </a-col>
        <a-col :span="3">
          {{ appStore }}
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import { Alipay, Wechat, AppStore } from "@icon-park/vue";

export default {
  components: {
    Alipay,
    Wechat,
    AppStore,
  },
  props: ["value", "title", "wechat", "alipay", "appStore"],
};
</script>

<style>
.subtitle {
  font-size: 12px;
}
</style>